import { EllipsedText, Loading, MaterialIcon, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { useStyles } from '../../hooks/useStyles';
import { fenceState, selectedFenceIdState } from '../../storage/fences';
import { getFenceTypeLabel } from '../../utils/fences';
import { StyledTooltip } from '../ui/StyledTooltip';

function FenceItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { classes, concatenateClasses, css, theme, overrides } = useStyles();
  const [selectedFenceId, setSelectedFenceId] = useRecoilState(selectedFenceIdState);
  const fenceId = data.items[index];
  const fence = useRecoilValue(fenceState(fenceId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedFenceId === fenceId;

  const onSelectFence = () => {
    if (selectedFenceId === fenceId) setSelectedFenceId(undefined);
    else setSelectedFenceId(fenceId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectFence,
            isHover,
            isSelected,
          })}
        >
          <ListItemLabel>
            <span
              className={concatenateClasses(
                classes.horizontalFlex,
                classes.centeredStart,
                css({ gap: theme.sizing.scale500 }),
              )}
            >
              <StyledTooltip
                content={fence?.active ? 'Activo' : 'Inactivo'}
                showArrow={false}
              >
                <MaterialIcon
                  name="place"
                  color={fence?.active ? theme.colors.contentPositive : theme.colors.contentStateDisabled}
                />
              </StyledTooltip>
              <span className={concatenateClasses(classes.verticalFlex)}>
                <EllipsedText
                  inline
                  breakAll
                >
                  {fence?.name || '-'}
                </EllipsedText>
                {fence?.fenceType && (
                  <EllipsedText
                    inline
                    style={{ ...theme.typography.ParagraphSmall }}
                  >
                    {getFenceTypeLabel(fence.fenceType) || '-'}
                  </EllipsedText>
                )}
              </span>
            </span>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(FenceItem);
